// Shared constants + API helpers for the task offcanvas components.
// Adjust BASE_URL / endpoint paths if your environment differs.

import { BASE_CRM_URL } from "../../../components/config/config";

export const BASE_URL = `${BASE_CRM_URL}`;

// Priority select shows labels, but the API expects numbers.
export const PRIORITY_OPTIONS = [
  { value: 3, label: "High" },
  { value: 2, label: "Medium" },
  { value: 1, label: "Low" },
  { value: 4, label: "Urgent" },
];

// Repeat every: 0 = None (matches your sample payload's repeat_every: 0)
export const REPEAT_OPTIONS = [
  { value: 0, label: "None" },
  { value: 1, label: "Daily" },
  { value: 2, label: "Weekly" },
  { value: 3, label: "Monthly" },
  { value: 4, label: "Yearly" },
];

// Hardcoded "Related To" options. Only lead/customer/project have a
// live-fetch wired up below (those are the APIs you shared so far).
export const RELATED_TO_OPTIONS = [
  { value: "lead", label: "Lead" },
  { value: "customer", label: "Customer" },
  { value: "project", label: "Project" },
  { value: "invoice", label: "Invoice" },
  { value: "expense", label: "Expense" },
  { value: "proposal", label: "Proposal" },
];

export const TAG_OPTIONS = [
  { value: "Big Ticket" },
  { value: "Test" },
  { value: "Website" },
  { value: "Positive" },
];

// ---- Fetchers ---------------------------------------------------------

export async function fetchStaffDropdown() {
  const res = await fetch(`${BASE_URL}staff/GetStaffDropdown`);
  const data = await res.json();
  return (data?.ResultData || []).map((s) => ({
    value: s.staffid,
    label: `${s.firstname || ""} ${s.lastname || ""}`.trim(),
  }));
}

// Returns [{ value, label }] for whichever rel_type is passed in.
// Returns [] for rel_types that don't have an API yet.
export async function fetchRelatedOptions(relType) {
  if (!relType) return [];

  if (relType === "project") {
    const res = await fetch(`${BASE_URL}project/GetProjects`);
    const data = await res.json();
    return (data?.ResultData || []).map((p) => ({
      value: p.id,
      label: p.name,
    }));
  }

  if (relType === "customer") {
    const res = await fetch(`${BASE_URL}customers/GetCustomers`);
    const data = await res.json();
    return (data?.ResultData || []).map((c) => ({
      value: c.customerId,
      label: c.company,
    }));
  }

  if (relType === "lead") {
    const res = await fetch(
      `${BASE_URL}leads/GetLeadsByStatus?statusId=0&sourceId=0&assignTo=0`,
    );
    const data = await res.json();
    return (data?.ResultData || []).map((l) => ({
      value: l.id,
      label: l.name,
    }));
  }

  // invoice / sales / expense / proposal: no API yet


    if (relType === "estimate") {
    const res = await fetch(`${BASE_URL}estimates/GetEstimates`);
    const data = await res.json();
    return (data?.ResultData || []).map((c) => ({
      value: c.id,
      label: c.Estimatenumber,
    }));
  }
 if (relType === "proposal") {
    const res = await fetch(`${BASE_URL}proposal/GetProposals`);
    const data = await res.json();
    return (data?.ResultData || []).map((c) => ({
      value: c.id,
      label: c.number,
    }));
  }
   if (relType === "invoice") {
    const res = await fetch(`${BASE_URL}invoice/GetInvoices`);
    const data = await res.json();
    return (data?.ResultData || []).map((c) => ({
      value: c.id,
      label: c.InvoiceNo,
    }));
  }


  return [];
}

export async function fetchTaskById(taskId) {
  const res = await fetch(`${BASE_URL}tasks/GetTaskByIdnew?taskid=${taskId}`);
  const data = await res.json();
  return data?.ResultData?.[0] || null;
}

export async function saveNewTask(payload) {
  const { assignments, ...rest } = payload;

  const updatedPayload = {
    ...rest,
    assignees: assignments,
  };

  const res = await fetch(`${BASE_URL}tasks/addTask`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedPayload),
  });

  return res.json();
}

// NOTE: endpoint name guessed — confirm the real update path.
export async function updateTask(taskId, payload) {
  const res = await fetch(`${BASE_URL}tasks/UpdateTask`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...payload,
      id: taskId,
    }),
  });

  return res.json();
}

// ---- Helpers ------------------------------------------------------------

// "2026-08-26T18:30:00.000Z" -> "2026-08-27" (for <input type="date">)
export function toDateInputValue(isoString) {
  if (!isoString) return "";
  return isoString.slice(0, 10);
}

export function buildTaskPayload(form) {
  return {
    name: form.name,
    description: form.description,
    priority: form.priority || null,
    startdate: form.startdate,
    duedate: form.duedate,
    repeat_every: form.repeat_every ?? 0,
    rel_id: form.rel_id,
    rel_type: form.rel_type,
    is_public: form.is_public ? 1 : 0,
    billable: form.billable ? 1 : 0,
    hourly_rate: form.hourly_rate ? Number(form.hourly_rate) : 0,
    status: form.status || 1,
    assignments: (form.assignments || []).map((staffid) => ({ staffid })),
    followers: (form.followers || []).map((staffid) => ({ staffid })),
  };
}
